import React from 'react';
import { useVersion } from '../contexts/VersionContext';

/**
 * Banner global afișat DOAR pe medii de test (staging/development).
 * Pe producție (appEnv === 'production') sau înainte de primul răspuns /version
 * nu se randează nimic. Scopul: să fie evident vizual că NU ești pe aplicația reală.
 */
const EnvironmentBanner: React.FC = () => {
  const { appEnv } = useVersion();

  if (!appEnv || appEnv === 'production') return null;

  const isStaging = appEnv === 'staging';
  const label = isStaging ? 'MEDIU DE TEST (STAGING)' : 'MEDIU DE DEZVOLTARE (LOCAL)';
  const bg = isStaging ? 'bg-amber-500' : 'bg-fuchsia-600';

  return (
    <div className={`${bg} text-white text-center text-xs font-semibold tracking-wide py-1 px-3 select-none`} role="status" aria-live="polite">
      🧪 {label} — modificările NU afectează aplicația reală. Emailurile și automatizările sunt controlate din Setări → Mediu &amp; Automatizări.
    </div>
  );
};

export default EnvironmentBanner;
